import * as React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { applicationEndpoints } from '../../../../../amorg-common/applicationEndpoints';
import { clientApi } from '../../../../../api/clientApi';
import { SingleColumnLayout } from '../../../../_layouts/SingleColumnLayout';
import { LoadingPageOverlay } from '../../../../../designSystem/LoadingPageOverlay';
import { PageHeader } from '../../../../../designSystem/PageHeader';
import { P } from '../../../../../designSystem/typography/Body';
import { PublicPageWrapper } from '../../../../_pageWrappers/PublicPageWrapper';

// type loginMethod = 'none' |'magicLink';

export function PortalAccessKeyPage(): JSX.Element {
    
    const params = useParams<{ siteId:string, accessKey:string }>();

    const [loading, setLoading] = React.useState(true);
    const [success, setSuccess] = React.useState<boolean | null>(null);

    React.useEffect(() => {
        async function getData() {
            if(!params.siteId || !params.accessKey)
            {
                setSuccess(false);
                setLoading(false);
                return;
            }

            const result = await clientApi.portal.accessKeyLogin(params.siteId, params.accessKey);
            setSuccess(result);
            setLoading(false);
        }
        getData();
    },[params.siteId, params.accessKey]);

    return (
        <PublicPageWrapper siteId={params.siteId}>

                {loading &&
                    <LoadingPageOverlay loading={true} />
                }

                {success 
                    
                    ?
                    <Navigate to={applicationEndpoints.portal} />

                    :
                    <>
                        <PageHeader narrow headerText="Bekræft login" />
                        <SingleColumnLayout narrow>
                            <>
                                <P>Vi kunne ikke logged dig ind.</P>
                                
                                <P>Kontakt din arbejdsmiljørepræsentant for hjælp.</P>
                            </>
                        </SingleColumnLayout>
                    </>
                }
        </PublicPageWrapper>
    );
}